import { CobaltClickableTile } from '@cae/cobalt-react/components/tile';
import { CobaltIconChevronRightSolid } from '@cae/cobalt-react/icons/solid/CobaltIconChevronRightSolid';
import { useVisibleProfileNavigationItems } from '@features/profile/hooks/use-visible-profile-navigation-items/useVisibleProfileNavigationItems';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './ProfileMobileNavigation.module.css';

const ProfileMobileNavigation = React.memo((): React.ReactElement => {
  const navigate = useNavigate();
  const visibleNavigationItems = useVisibleProfileNavigationItems();

  const handleNavigation = React.useCallback(
    (path: string): void => {
      navigate(path);
    },
    [navigate]
  );

  const clickHandlers = React.useMemo<Record<string, () => void>>(
    () =>
      Object.fromEntries(
        visibleNavigationItems.map(item => [
          item.path,
          () => handleNavigation(item.path),
        ])
      ),
    [handleNavigation, visibleNavigationItems]
  );

  return (
    <div className={styles.menuLayout} data-heap-id="profile-mobile-navigation">
      <div className={styles.actions}>
        {visibleNavigationItems.map(item => (
          <CobaltClickableTile
            key={item.path}
            data-heap-id={`profile-mobile-nav-${item.heapId}`}
            className={styles.item}
            onClick={clickHandlers[item.path]}
          >
            <div className={styles.label}>{item.label}</div>
            <CobaltIconChevronRightSolid size="small" />
          </CobaltClickableTile>
        ))}
      </div>
    </div>
  );
});

ProfileMobileNavigation.displayName = 'ProfileMobileNavigation';

export { ProfileMobileNavigation };
